module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp3_8011.f49913e6.png";